import { render, staticRenderFns } from "./CoreSnackbar.vue?vue&type=template&id=60272858&scoped=true&"
import script from "./CoreSnackbar.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CoreSnackbar.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CoreSnackbar.vue?vue&type=style&index=0&id=60272858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60272858",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60272858')) {
      api.createRecord('60272858', component.options)
    } else {
      api.reload('60272858', component.options)
    }
    module.hot.accept("./CoreSnackbar.vue?vue&type=template&id=60272858&scoped=true&", function () {
      api.rerender('60272858', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CoreSnackbar/CoreSnackbar.vue"
export default component.exports